export default "__VITE_ASSET__CZxE9HVj__"